import BaseAPI from "api/BaseAPI";
import CookieHelper from "helpers/cookie";
class Authentication extends BaseAPI {
	async loginUser(data) {
		try {
			let response =  await this.init().post("/account/login", data);
			return response;
		} catch(error) {
			return error.response;
		}
	}

	async signin(data) {
		try {
			let response =  await this.init().post("/account/signup", data);
			return response;
		} catch(error) {
			return error.response;
		}
	}
	
	async verifyAccount(verificationKey) {
		try {
			let response =  await this.init().get("/account/verify/"+verificationKey);
			return response;
		} catch(error) {
			return error.response;
		}
	}	

	async logoutUser() {
		try {
			let response =  await this.init().get("/account/logout");
			
			return response;
		} catch(error) {
			return error.response;
		}
	}

	async resetPassword(data) {
		try {
			let response =  await this.init().post("/account/resetpassword", data);
			return response;
		} catch(error) {
			return error.response;
		}
	}

	async resetPasswordVerify(verifyKey, data) {
		try {
			let response =  await this.init().post("/account/password/recover/"+verifyKey, data);
			return response;
		} catch(error) {
			return error.response;
		}
	}
}

export default new Authentication();